import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-message-confirm-modal',
  templateUrl: './message-confirm-modal.component.html',
  styleUrls: ['./message-confirm-modal.component.css']
})
export class MessageConfirmModalComponent implements OnInit {

  @Input() msg: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
